import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { atxWidth$ } from '@epicuro-next/ataraxia/breakpoint';
import { HorizontalProductV2Component } from '@epicuro-next/ataraxia/horizontal-product-card';
import {
  LoaderOverlayModule,
  OverlayType,
} from '@epicuro-next/ataraxia/loader-overlay';
import { PopoverModule } from '@epicuro-next/ataraxia/popover';
import { Placement } from '@epicuro-next/utilities';
import { SuggestService } from 'data-recommendation';
import { Product } from 'graphql-api/gql-api-interfaces';
import { map, shareReplay } from 'rxjs';

import { BoughtThisSeasonProductsStore } from '../../services/bought-this-season.component.store';

const BOUGHT_THIS_SEASON_PRODUCTS_MOBILE_BREAKPOINT = 1592;

@Component({
  selector: 'epc-bought-this-season-products',
  imports: [
    CommonModule,
    LoaderOverlayModule,
    HorizontalProductV2Component,
    PopoverModule,
  ],
  templateUrl: './bought-this-season-products.component.html',
  styleUrl: './bought-this-season-products.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [BoughtThisSeasonProductsStore, SuggestService],
})
export class BoughtThisSeasonProductsComponent {
  private suggestProductsStore = inject(BoughtThisSeasonProductsStore);

  public readonly hasError = this.suggestProductsStore.hasError;
  public readonly isLoading = this.suggestProductsStore.isLoading;
  public readonly isLoaded = this.suggestProductsStore.isLoaded;
  public readonly products = this.suggestProductsStore.items;

  public readonly isDesktop = toSignal(
    atxWidth$.pipe(
      map((width) => width > BOUGHT_THIS_SEASON_PRODUCTS_MOBILE_BREAKPOINT),
      shareReplay({ bufferSize: 1, refCount: true }),
    ),
  );

  public popoverPlacement: Placement = Placement.BOTTOM;
  public overlayType: OverlayType = OverlayType.STATIC;

  public preloadProducts() {
    this.suggestProductsStore.loadBoughtThisSeasonProducts();
  }

  public onProductClick(product: Product) {
    this.suggestProductsStore.handleProductClick(product);
  }
}
